export const MINIMUM_LAP_TIME = 10000;

export const DOUBLE_TAP_DELAY = 300;

export const STYLES = {
  mainContainer: {
    position: 'relative',
    my: 4
  },
  headerBox: {
    position: { xs: 'static', sm: 'absolute' },
    top: 0,
    right: 0,
    bgcolor: 'background.paper',
    p: 2,
    borderRadius: 1,
    boxShadow: 1,
    mb: { xs: 2, sm: 0 },
    zIndex: 1,
    display: 'flex',
    gap: 3
  },
  timerPaper: {
    p: { xs: 2, sm: 4 },
    mb: 4,
    textAlign: 'center'
  },
  timerDisplay: {
    fontSize: { xs: '2.5rem', sm: '3.75rem' },
    fontFamily: 'monospace'
  },
  swimmerName: {
    mt: 2,
    color: 'primary.main',
    fontWeight: 'bold',
    fontSize: { xs: '1.2rem', sm: '1.5rem' }
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 2,
    mt: 4
  },
  startButton: {
    py: 1.5,
    fontSize: { xs: '1rem', sm: '1.1rem' }
  },
  stopButton: {
    width: { xs: '100%', sm: '30%' },
    py: 1.5,
    fontSize: { xs: '1rem', sm: '1.1rem' }
  },
  nextButton: {
    width: { xs: '100%', sm: '70%' },
    py: 1.5,
    fontSize: { xs: '1rem', sm: '1.1rem' }
  },
  addSwimmerContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 2,
    mb: 4
  },
  addButton: {
    minWidth: { xs: '100%', sm: '120px' }
  },
  actionButtonsContainer: {
    mt: 4,
    display: 'flex',
    justifyContent: 'center',
    gap: 2
  },
  endButton: {
    minWidth: '200px',
    py: 1.5
  },
  resultsButton: {
    minWidth: '200px',
    py: 1.5
  }
};